import axios from "axios";
import { Message } from "@arco-design/web-react";
import { getTokenToLocalStorage } from "@/utils/token";
import { whiteListRequest } from "@/config/whiteLIst";
import { startRequest, endRequest } from "./tool";

const service = axios.create({ timeout: 100000 });
// 当所有请求都结束时触发
const close = (message?: string) => {
  setTimeout(() => {
    endRequest(() => {
      if (message) Message.error(message);
    });
  }, 200);
};

let messageIns = null;

// 请求拦截器
service.interceptors.request.use((config) => {
  startRequest();
  config.headers["AID"] = process.env.REACT_APP_AID;
  config.headers["PlatForm"] = process.env.REACT_PLATFORM;
  // config.headers['Device'] = 'web_client'
  const requestUrl = config.url;
  const isWhitelisted = whiteListRequest.some((route) => route === requestUrl);
  if (!isWhitelisted && !location.pathname.includes('/agreement')) {
    const token = getTokenToLocalStorage();
    const currentPath = window.location.pathname + window.location.search;
    if (!token) {
      window.location.href = `/login?next=${currentPath}`;
      return Promise.reject("没有找到 Token，请重新登录");
    }
    try {
      const tokenParts = token.split(".");
      if (tokenParts.length !== 3) {
        throw new Error("Token 格式不正确");
      }
      const payload = tokenParts[1];
      // 特殊字符处理 解决非 ASCII 字符或转义字符 parse 报错
      const decodeData = atob(payload)
        .split("")
        .map((item) => "%" + ("00" + item.charCodeAt(0).toString(16)).slice(-2))
        .join("");
      const decodedPayload = JSON.parse(decodeURIComponent(decodeData));
      // exp 时间戳
      const exp = decodedPayload.exp;
      const currentTime = Math.floor(Date.now() / 1000);
      // Token 是否过期
      if (exp < currentTime) {
        window.location.href = `/login?next=${currentPath}`;
        if (!messageIns) {
          messageIns = Message.error("Token 已过期，请重新登录");
          setTimeout(() => {
            messageIns = null;
          }, 2000);
        }
        return Promise.reject("Token 已过期，请重新登录");
      } else {
        config.headers["Token"] = `${token}`;
        // config.headers['Device'] = 'web_client'
        return config;
      }
    } catch (e) {
      // window.location.href = `/login?next=${currentPath}`
      // Message.error('Token 无效，请重新登录')
      // return Promise.reject('Token 无效，请重新登录')
      if (!messageIns) {
        messageIns = Message.error({
          content: "Token 无效，请重新登录",
          duration: 2000,
        });

        setTimeout(() => {
          messageIns = null;
        }, 2000);
      }
    }
  }
  return config;
});

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.config.url.includes("graphql")) {
      if (response.data.data) {
        close();
        return Promise.resolve(response.data);
      } else {
        close();
        return Promise.reject(response.data.message);
      }
    }
    if (response.headers["content-type"] === "text/event-stream") {
      close();
      return Promise.resolve(response.data);
    }

    if (
      response.config.url === "/api/v1/video/task/export" ||
      response.config.url === "/api/v1/video/task/business"
    ) {
      close();
      return Promise.resolve(response.data);
    }

    if (response.status === 200 || response.status === 207) {
      if (response.data.code === 0) {
        close();
        return Promise.resolve(response.data);
      } else {
        close();
        return Promise.reject(response.data.message);
      }
    }
    close();
    return Promise.resolve(response);
  },
  (error) => {
    console.log("error ===>", error);
    if (error.response && error.response.status === 401) {
      close("登录已过期，请重新登录");
      window.localStorage.clear();
      window.location.href = `/login?next=${window.location.pathname + window.location.search}`;
      return;
    }
    if (error.response && error.response.status === 400) {
      close(error.response.data.message);
      return Promise.reject(error.response.data.message);
    }
    close();
    return Promise.reject(error);
  }
);

export default service;
